"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
type CaptureCountdownOverlayProps = {
  countdown: number | null;
};
const RING_SIZE = 140;
const RING_STROKE = 4;
const RING_RADIUS = (RING_SIZE - RING_STROKE) / 2;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
export function CaptureCountdownOverlay(t0) {
  const $ = _c(4);
  const {
    countdown
  } = t0;
  let t1;
  if ($[0] !== countdown) {
    t1 = countdown !== null && countdown > 0 && <motion.div animate={{
      opacity: 1
    }} className="absolute inset-0 z-10 flex items-center justify-center" exit={{
      opacity: 0,
      transition: {
        duration: 0.15
      }
    }} initial={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }}><div className="relative flex items-center justify-center"><svg aria-hidden={true} className="-rotate-90" height={RING_SIZE} width={RING_SIZE}><circle className="stroke-white/10" cx={RING_SIZE / 2} cy={RING_SIZE / 2} fill="none" r={RING_RADIUS} strokeWidth={RING_STROKE} /><motion.circle animate={{
            strokeDashoffset: 0
          }} className="stroke-white/80" cx={RING_SIZE / 2} cy={RING_SIZE / 2} fill="none" initial={{
            strokeDashoffset: RING_CIRCUMFERENCE
          }} key={countdown} r={RING_RADIUS} strokeDasharray={RING_CIRCUMFERENCE} strokeLinecap="round" strokeWidth={RING_STROKE} transition={{
            duration: 1,
            ease: "linear"
          }} /></svg><div className="absolute inset-0 flex items-center justify-center"><AnimatePresence mode="sync"><motion.span animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }} className="text-overlay-foreground font-light drop-shadow-lg" exit={{
              opacity: 0,
              scale: 0.6,
              y: 10,
              transition: {
                duration: 0.15
              }
            }} initial={{
              opacity: 0,
              scale: 1.4,
              y: -12
            }} key={countdown} style={{
              fontSize: "clamp(48px, 14vw, 72px)",
              lineHeight: 1
            }} transition={{
              duration: 0.2,
              ease: "easeOut"
            }}>{countdown}</motion.span></AnimatePresence></div></div></motion.div>;
    $[0] = countdown;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}